import { Button, Col, Row, Container, Table } from 'react-bootstrap';
import toast, { Toaster } from "react-hot-toast";
import { useState, useEffect } from 'react';
import '../../css/common.css';
import '../../css/hover.css'
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { saveForm, deleteForm } from '../../store/Slices/formSlice';
import useValidation from '../../helpers/validation';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';

function TollfreeEnglish() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userEmail = sessionStorage.getItem('email');

    useEffect(() => {
        const fetchData = async () => {
            if (!userEmail) {
                navigate('/');
                return;
            }
            const form = JSON.parse(localStorage.getItem('form'));

            if (form?.country?.country === 'TollfreeEnglish') {
                fillForm(form);
            }
        };

        fetchData();
    }, [dispatch, navigate]);

    const { validateInput, validationStates, setValidationStates } = useValidation();

    const [operator, setOperator] = useState('');
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [zip, setZip] = useState('');

    const [custName, setCustName] = useState('');
    const [vat, setVat] = useState('');
    const [custAddress, setCustAddress] = useState('');
    const [custCity, setCustCity] = useState('');
    const [custZip, setCustZip] = useState('');
    const [accNum, setAccNum] = useState('');
    const [mbn, setMbn] = useState('');
    const [sign, setSign] = useState('');
    const [date, setDate] = useState('');
    const [printName, setPrintName] = useState('');
    const [position, setPosition] = useState('');
    const [contactNumber, setContactNumber] = useState('');

    //-----------------------------------------------FillForm-------------------------------------------------//

    const fillForm = (form) => {
        const JSONDATA = form;

        setOperator(JSONDATA?.country?.operatorDetails?.operator ?? '');
        setAddress(JSONDATA?.country?.operatorDetails?.address ?? '');
        setCity(JSONDATA?.country?.operatorDetails?.city ?? '');
        setZip(JSONDATA?.country?.operatorDetails?.zip ?? '');
        document.querySelector('#operator').value = JSONDATA?.country?.operatorDetails?.operator ?? '';
        document.querySelector('#address').value = JSONDATA?.country?.operatorDetails?.address ?? '';
        document.querySelector('#city').value = JSONDATA?.country?.operatorDetails?.city ?? '';
        document.querySelector('#zip').value = JSONDATA?.country?.operatorDetails?.zip ?? '';

        setCustName(JSONDATA?.country?.clientDetails?.custName ?? '');
        setVat(JSONDATA?.country?.clientDetails?.vat ?? '');
        setCustAddress(JSONDATA?.country?.clientDetails?.custAddress ?? '');
        setCustCity(JSONDATA?.country?.clientDetails?.custCity ?? '');
        setCustZip(JSONDATA?.country?.clientDetails?.custZip ?? '');
        setAccNum(JSONDATA?.country?.clientDetails?.accNum ?? '');

        document.querySelector('#custName').value = JSONDATA?.country?.clientDetails?.custName ?? '';
        document.querySelector('#vat').value = JSONDATA?.country?.clientDetails?.vat ?? '';
        document.querySelector('#custAddress').value = JSONDATA?.country?.clientDetails?.custAddress ?? '';
        document.querySelector('#custCity').value = JSONDATA?.country?.clientDetails?.custCity ?? '';
        document.querySelector('#custZip').value = JSONDATA?.country?.clientDetails?.custZip ?? '';
        document.querySelector('#accNum').value = JSONDATA?.country?.clientDetails?.accNum ?? '';

        setTableDataRange(JSONDATA?.country?.customer?.tableDataRange ?? []);
        setMbn(JSONDATA?.country?.customer?.mbn ?? '');
        setSign(JSONDATA?.country?.customer?.sign ?? '');
        setDate(JSONDATA?.country?.customer?.date ?? '');
        setPrintName(JSONDATA?.country?.customer?.printName ?? '');
        setPosition(JSONDATA?.country?.customer?.position ?? '');
        setContactNumber(JSONDATA?.country?.customer?.contactNumber ?? '');
        document.querySelector('#mbn').value = JSONDATA?.country?.customer?.mbn ?? '';
        document.querySelector('#sign').value = JSONDATA?.country?.customer?.sign ?? '';
        document.querySelector('#date').value = JSONDATA?.country?.customer?.date ?? '';
        document.querySelector('#printName').value = JSONDATA?.country?.customer?.printName ?? '';
        document.querySelector('#position').value = JSONDATA?.country?.customer?.position ?? '';
        document.querySelector('#contactNumber').value = JSONDATA?.country?.customer?.contactNumber ?? ''

    }

    //-----------------------------------------------Hover-------------------------------------------------//

    const [hoveredField, setHoveredField] = useState(null); //hovered field

    const handleMouseEnter = (field) => {
        setHoveredField(field);
    };

    const handleMouseLeave = () => {
        setHoveredField(null);
    };

    //--------------------------------table declaration (DID Range)--------------------------------------//

    const [tableDataRange, setTableDataRange] = useState([{ id: Date.now(), sNumber: '', eNumber: '' }]);

    //adding a row
    const addRow_range = () => {
        setTableDataRange([...tableDataRange, { id: Date.now(), sNumber: '', eNumber: '' }]);
    };

    //removing a row
    const removeRow_range = (id) => {
        setTableDataRange(tableDataRange.filter(row => row.id !== id));
    };

    //change handler of table
    const handleChange_tableRange = (id, key, value) => {
        const updatedData = tableDataRange.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableDataRange(updatedData);
    };

    const fileInputRef = React.createRef();  // Create a reference to the file input element
    const [uploadedFileName, setUploadedFileName] = useState('');

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setUploadedFileName(file.name);

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            // Read headers from row 5 (0-indexed, so index 4)
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, range: 4 });
            if (!jsonData.length) {
                toast.error('Uploaded file is empty or has an invalid format.');
                setUploadedFileName('');
                return;
            }

            const fileHeaders = jsonData[0] || [];
            const expectedHeaders = ['Public from', 'Public to', 'Private from', 'Private to', 'Local Country Value'];

            // Check if headers match
            if (!expectedHeaders.every((header, index) => header === fileHeaders[index])) {
                toast.error('Uploaded file does not match the expected format.');
                setUploadedFileName('');
                return;
            }

            // Read actual data from row 6 onwards
            const dataRows = jsonData.slice(1);

            // Extract relevant data for tableDataRange
            const formattedDataRange = dataRows.map((row, index) => ({
                id: index + 1,
                sNumber: row[0] ? row[0].toString() : '',
                eNumber: row[1] ? row[1].toString() : '',
            }));

            setTableDataRange(formattedDataRange);

            // Validate each row: must be numeric and not empty
            formattedDataRange.forEach(row => {
                const isStartValid = /^[0-9]+$/.test(row.sNumber);
                const isEndValid = /^[0-9]+$/.test(row.eNumber);

                setValidationStates(prev => ({
                    ...prev,
                    [`startNumber-${row.id}`]: isStartValid,
                    [`endNumber-${row.id}`]: isEndValid,
                }));
            });
        };

        reader.readAsArrayBuffer(file);
    };

    const removeUploadedFile = () => {
        setUploadedFileName('');
        fileInputRef.current.value = '';
        setTableDataRange([{ id: Date.now(), sNumber: '', eNumber: '' }]);
    };

    const handleDownload = async () => {
        try {
            // Fetch the file (portabilityImportTemplate.xlsx) from the server
            const response = await fetch(`/portabilityImportTemplate.xlsx?t=${new Date().getTime()}`);

            // Check if the response is valid
            if (!response.ok) throw new Error("Network response was not ok");

            // Convert the response to a Blob
            const blob = await response.blob();

            // Create a URL for the Blob to allow it to be downloaded
            const url = window.URL.createObjectURL(blob);

            // Create an anchor tag dynamically and trigger a click to download the file
            const a = document.createElement("a");
            a.href = url;
            a.download = "portabilityImportTemplate.xlsx"; // File name for download
            document.body.appendChild(a);
            a.click(); // Initiate the download
            document.body.removeChild(a); // Clean up by removing the anchor element
        } catch (error) {
            // Catch any error that occurs during the download process
            console.error("Download failed:", error);
        }
    };

    //-------------------------------------------creating Schema----------------------------------------//

    const json = {
        "country": {
            "country": "TollfreeEnglish",

            "operatorDetails": {
                "operator": operator,
                "address": address,
                "city": city,
                "zip": zip
            },

            "clientDetails": {
                "custName": custName,
                "vat": vat,
                "custAddress": custAddress,
                "custCity": custCity,
                "custZip": custZip,
                "accNum": accNum
            },

            "customer": {
                "tableDataRange": tableDataRange,
                "mbn": mbn,
                "sign": sign,
                "date": date,
                "printName": printName,
                "position": position,
                "contactNumber": contactNumber
            },
        },
        "email": sessionStorage.getItem('email'),
    };

    const jsonString = JSON.stringify(json);
    console.log(jsonString);

    //-----------------------------------------sending request---------------------------------------------//

    async function Submit(e) {
        let validationErrors = {};

        if (!operator) {
            validationErrors.operator = 'Please fill in Operator Name';
        }
        if (!address) {
            validationErrors.address = 'Please fill in Address';
        }
        if (!city) {
            validationErrors.city = 'Please fill in City';
        }
        if (!zip) {
            validationErrors.zip = 'Please fill in Zip';
        }
        if (!custName) {
            validationErrors.custName = 'Please fill in Customer Name';
        }
        if (!custAddress) {
            validationErrors.custAddress = 'Please fill in Address';
        }
        if (!custCity) {
            validationErrors.custCity = 'Please fill in City';
        }
        if (!custZip) {
            validationErrors.custZip = 'Please fill in Zip';
        }
        if (!accNum) {
            validationErrors.accNum = 'Please fill in Account Number';
        }

        // Ensure both Start Number and End Number are provided in Range Table
        tableDataRange.forEach(row => {
            const startId = `startNumber-${row.id}`;
            const endId = `endNumber-${row.id}`;

            // Validate start number
            if (!row.sNumber) {
                validationErrors[startId] = 'Please fill in the start of the number range.';
            } else if (!/^[0-9]+$/.test(row.sNumber)) {
                validationErrors[startId] = 'Start number must be numeric.';
            }

            // Validate end number
            if (!row.eNumber) {
                validationErrors[endId] = 'Please fill in the end of the number range.';
            } else if (!/^[0-9]+$/.test(row.eNumber)) {
                validationErrors[endId] = 'End number must be numeric.';
            }
        });

        if (!sign) {
            validationErrors.sign = 'Please fill in Signed by';
        }
        if (!date) {
            validationErrors.date = 'Please fill in Date';
        }
        if (!printName) {
            validationErrors.printName = 'Please fill in Contact Print Name';
        }
        if (!contactNumber) {
            validationErrors.contactNumber = 'Please fill in Contact Number';
        }

        const hasValidationError = Object.values(validationErrors).length > 0;

        if (hasValidationError) {
            // Update validation states
            setValidationStates(prevState => ({
                ...prevState,
                ...Object.keys(validationErrors).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {})
            }));

            // Show the first error message and scroll to the field if it exists
            const firstError = Object.values(validationErrors)[0];
            const firstErrorKey = Object.keys(validationErrors)[0];
            const firstErrorElement = document.getElementById(firstErrorKey);

            if (firstErrorElement) {
                firstErrorElement.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            } else {
                console.error(`Element with ID ${firstErrorKey} not found.`);
                toast.error("An error occurred while scrolling to the invalid field.");
            }

            toast.error(firstError);
            return;
        }

        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => value === false)
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            toast.error(`Please make sure fields in red are correct. \n${falseKeys}`);
            const elem = document.getElementById(falseKeys[0]);
            if (elem) {
                elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            } else {
                console.error(`Element with ID ${falseKeys[0]} not found.`);
            }
            return;
        }

        // If all validations pass, proceed with the form submission
        e.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/generate_loa`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: jsonString
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blobData = await response.blob();
            const url = URL.createObjectURL(blobData);
            const a = document.createElement('a');
            a.href = url;
            a.download = operator + '-LOA.docx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading file: ', error);
            window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home';
        }
    }

    //----------------------------------------------RESET--------------------------------------------------//

    async function Reset(e) {
        const dataToBeDeleted = { "email": userEmail };
        dispatch(deleteForm(dataToBeDeleted));
        localStorage.removeItem('form');
        window.location.reload();
    }

    // ----------------------------------------------SAVE--------------------------------------------------//

    async function save(e) {
        e.preventDefault();
        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => {
                const element = document.getElementById(key);
                return value === false && element && element.value.trim() !== '';
            })
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(`Please make sure following fields in red are correct before saving `);
            return;
        }

        localStorage.setItem('form', JSON.stringify(json));
        const dataToBeSaved = { "email": userEmail, "json_data": json };
        try {
            const response = await dispatch(saveForm(dataToBeSaved));
            if (response?.payload?.message === "success") {
                toast.success('Form saved successfully');
            }
        } catch (error) {
            toast.error('There was an error processing your request.');
        }
    }

    //-----------------------------------------------JSX----------------------------------------------------//

    return (
        <div>

            <Toaster position="top-center" reverseOrder={false}></Toaster>

            <div className='french'>

                <p><strong>Mandatory fields are marked by *</strong></p>

                <Container>

                    <h2 className='heading'>Donor / Losing operator</h2> <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('operator')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Operator Name*</label> <br />
                            <input
                                onChange={(e) => setOperator(e.target.value)}
                                type="text"
                                id='operator'
                                placeholder=""
                                className={`inputbox ${validationStates.operator === false ? 'error' : ''}`}
                                onBlur={() => validateInput('operator', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'operator' && (
                                <div className="hover-description">
                                    Enter the operator name
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('address')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Address*</label>
                            <input
                                onChange={(e) => setAddress(e.target.value)}
                                type="text"
                                id="address"
                                placeholder=""
                                className={`inputbox ${validationStates.address === false ? 'error' : ''}`}
                                onBlur={() => validateInput('address', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'address' && (
                                <div className="hover-description">
                                    Enter address.
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('city')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>City*</label>
                            <input
                                onChange={(e) => setCity(e.target.value)}
                                type="text"
                                id="city"
                                placeholder=""
                                className={`inputbox ${validationStates.city === false ? 'error' : ''}`}
                                onBlur={() => validateInput('city', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'city' && (
                                <div className="hover-description">
                                    Enter City.
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('zip')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Zip*</label>
                            <input
                                onChange={(e) => setZip(e.target.value)}
                                type="text"
                                id="zip"
                                placeholder=""
                                className={`inputbox ${validationStates.zip === false ? 'error' : ''}`}
                                onBlur={() => validateInput('zip', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'zip' && (
                                <div className="hover-description">
                                    Enter Zip.
                                </div>
                            )}
                        </Col>
                    </Row>

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Customer Details</h2> <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('custName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Customer name*</label> <br />
                            <input
                                onChange={(e) => setCustName(e.target.value)}
                                type="text"
                                id='custName'
                                placeholder=""
                                className={`inputbox ${validationStates.custName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('custName', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'custName' && (
                                <div className="hover-description">
                                    Enter Customer name
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('vat')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>VAT / registration number</label>
                            <input
                                onChange={(e) => setVat(e.target.value)}
                                type="text"
                                id="vat"
                                placeholder=""
                                className={`inputbox`}
                            />

                            {hoveredField === 'vat' && (
                                <div className="hover-description">
                                    Enter VAT / registration number.
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('custAddress')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Address*</label>
                            <input
                                onChange={(e) => setCustAddress(e.target.value)}
                                type="text"
                                id="custAddress"
                                placeholder=""
                                className={`inputbox ${validationStates.custAddress === false ? 'error' : ''}`}
                                onBlur={() => validateInput('custAddress', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'custAddress' && (
                                <div className="hover-description">
                                    Enter Address.
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('custCity')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>City*</label>
                            <input
                                onChange={(e) => setCustCity(e.target.value)}
                                type="text"
                                id="custCity"
                                placeholder=""
                                className={`inputbox ${validationStates.custCity === false ? 'error' : ''}`}
                                onBlur={() => validateInput('custCity', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'custCity' && (
                                <div className="hover-description">
                                    Enter City.
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('custZip')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Zip*</label>
                            <input
                                onChange={(e) => setCustZip(e.target.value)}
                                type="text"
                                id="custZip"
                                placeholder=""
                                className={`inputbox ${validationStates.custZip === false ? 'error' : ''}`}
                                onBlur={() => validateInput('custZip', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'custZip' && (
                                <div className="hover-description">
                                    Enter Zip.
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('accNum')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Customer Account Number at Donor*</label>
                            <p>(*as shown on most recent telecommunications bill from donor)</p>
                            <input
                                onChange={(e) => setAccNum(e.target.value)}
                                type="text"
                                id="accNum"
                                placeholder=""
                                className={`inputbox ${validationStates.accNum === false ? 'error' : ''}`}
                                onBlur={() => validateInput('accNum', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'accNum' && (
                                <div className="hover-description">
                                    Enter Account Number.
                                </div>
                            )}
                        </Col>
                    </Row>

                </Container>

                <br></br><br></br>

                <Container>
                    <p><strong>Note : This document is to authorise the porting of the below numbers.</strong></p>

                    <h4 className='text-decoration-underline'>Number Range</h4> <br></br>

                    <Row>
                        <Col>
                            <button className="inputbox" onClick={handleDownload} style={{ alignItems: 'center' }}>
                                <FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px' }} />
                                Download number range template
                            </button>
                        </Col>

                        <Col>
                            <button
                                variant="secondary"
                                className="inputbox"
                                style={{ alignItems: 'center' }}
                                onClick={() => fileInputRef.current.click()}
                            >
                                <FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px' }} />
                                Upload File
                            </button>
                            <input
                                id="fileUploadInput"
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileUpload}
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                            />
                        </Col>

                        <Col>
                            {uploadedFileName && (
                                <button onClick={removeUploadedFile} className="inputbox" style={{ alignItems: 'center' }}>
                                    <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                    Remove
                                </button>
                            )}
                        </Col>

                    </Row>

                    <br />
                    <p>The template is the same used for the btd portability request.</p>
                    <br />

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>Start Range*</th>
                                <th>End Range*</th>
                            </tr>
                        </thead>

                        <tbody>

                            {tableDataRange.map(row => (
                                <tr key={row.id}>

                                    {/* Start Range */}
                                    <td
                                        onMouseEnter={() => handleMouseEnter(`startNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`startNumber-${row.id}`}
                                            value={row.sNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                handleChange_tableRange(row.id, 'sNumber', value);

                                                const isValid = /^[0-9]+$/.test(value);
                                                setValidationStates(prev => ({
                                                    ...prev,
                                                    [`startNumber-${row.id}`]: isValid,
                                                }));
                                            }}
                                            className={`inputbox ${validationStates[`startNumber-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                const isValid = /^[0-9]+$/.test(row.sNumber);
                                                if (!isValid) {
                                                    toast.error('Only numeric input allowed and cannot be empty.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `startNumber-${row.id}` && (
                                            <div className="hover-description">
                                                Enter the start number in a range
                                            </div>
                                        )}
                                        {validationStates[`startNumber-${row.id}`] === false && (
                                            <div className="error-message">
                                                Only numeric input allowed and cannot be empty.
                                            </div>
                                        )}
                                    </td>

                                    {/* End Number */}
                                    <td
                                        onMouseEnter={() => handleMouseEnter(`endNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`endNumber-${row.id}`}
                                            value={row.eNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                handleChange_tableRange(row.id, 'eNumber', value);

                                                const isValid = /^[0-9]+$/.test(value); // Exactly 11 digits
                                                setValidationStates(prev => ({
                                                    ...prev,
                                                    [`endNumber-${row.id}`]: isValid,
                                                }));
                                            }}
                                            className={`inputbox ${validationStates[`endNumber-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                const isValid = /^[0-9]+$/.test(row.eNumber);
                                                if (!isValid) {
                                                    toast.error('Only numeric input allowed and cannot be empty.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `endNumber-${row.id}` && (
                                            <div className="hover-description">
                                                Enter the end number in a range
                                            </div>
                                        )}
                                        {validationStates[`endNumber-${row.id}`] === false && (
                                            <div className="error-message">
                                                Only numeric input allowed and cannot be empty.
                                            </div>
                                        )}
                                    </td>

                                    <td>
                                        {tableDataRange.length > 1 && (
                                            <button onClick={() => removeRow_range(row.id)}>Remove</button>
                                        )}
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>
                    <button onClick={addRow_range}>Add Row</button>

                    <br></br><br></br> <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('mbn')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Main Billing Number for range</label>
                            <input
                                onChange={(e) => setMbn(e.target.value)}
                                type="text"
                                id="mbn"
                                placeholder=""
                                className={`inputbox ${validationStates.mbn === false ? 'error' : ''}`}
                                onBlur={(e) => {
                                    const value = e.target.value.trim();
                                    const isValid = value === '' || /^[0-9]+$/u.test(value);
                                    setValidationStates(prev => ({ ...prev, mbn: isValid }));

                                    if (value !== '' && !isValid) {
                                        toast.error(
                                            'Only numeric values are allowed.'
                                        );
                                    }
                                }}
                            />
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('sign')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Signed By*</label>
                            <input
                                onChange={(e) => setSign(e.target.value)}
                                type="text"
                                id="sign"
                                placeholder=""
                                className={`inputbox ${validationStates.sign === false ? 'error' : ''}`}
                                onBlur={() => validateInput('sign', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'sign' && (
                                <div className="hover-description">
                                    Enter authorized person name.
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('date')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Date*</label> <br />
                            <input
                                type="date"
                                id="date"
                                value={date}
                                onChange={(e) => setDate(e.target.value)}
                                min={new Date().toISOString().slice(0, 16)} // Disable past dates
                                className={`inputbox ${validationStates.date === false ? 'error' : ''}`}
                                onBlur={() => validateInput('date', /^.*$/)}
                            />
                            {hoveredField === 'date' && (
                                <div className="hover-description">
                                    Enter Date
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('printName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Contact Print Name*</label>
                            <input
                                onChange={(e) => setPrintName(e.target.value)}
                                type="text"
                                id="printName"
                                placeholder=""
                                className={`inputbox ${validationStates.printName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('printName', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'printName' && (
                                <div className="hover-description">
                                    Enter Contact Print Name.
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('position')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Position in Company</label>
                            <input
                                onChange={(e) => setPosition(e.target.value)}
                                type="text"
                                id="position"
                                placeholder=""
                                className={`inputbox`}
                            />

                            {hoveredField === 'position' && (
                                <div className="hover-description">
                                    Enter Position in Company.
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('contactNumber')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Contact Number*</label>
                            <input
                                onChange={(e) => setContactNumber(e.target.value)}
                                type="text"
                                id="contactNumber"
                                placeholder=""
                                className={`inputbox ${validationStates.contactNumber === false ? 'error' : ''}`}
                                onBlur={() => validateInput('contactNumber', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'contactNumber' && (
                                <div className="hover-description">
                                    Enter Contact Number.
                                </div>
                            )}
                        </Col>
                    </Row>
                </Container>

                <br></br><br></br>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="primary" type="save" onClick={save}>Save</Button>
                    <Button variant="primary" type="submit" onClick={Submit}>Generate LOA</Button>
                    {/* <Button variant="primary" type="autofill" onClick={autofill}>Autofill</Button> */}
                    <Button variant="primary" type="reset" onClick={Reset} style={{ marginRight: '20px' }}>Reset</Button>
                </div>
            </div>

        </div>
    );
}

export default TollfreeEnglish;